import { RelatedMedia } from "@/types/Media";
import { User } from "@/types/User";
import { BlogPostType } from "@/utils/BlogPostSlug";
import { toRelativeDate } from "@/utils/dateUtils";
import { capitalize } from "@/utils/stringUtils";
import { getUploadUrl } from "@/utils/uploadUtils";
import Image from "next/image";
import Link from "next/link";
import React from "react";
import Avatar from "src/components/atoms/Avatar";
import Tag from "src/components/atoms/Tag";
interface PostProps {
  attributes: {
    title: string;
    description: string;
    publishedAt: string;
    image: RelatedMedia;
    author: {
      id: number;
      data: {
        attributes: User;
      };
    };
    slug: string;
    hook: string;
  };
}

const ArticleListItem: React.FC<{ post: PostProps }> = ({ post }) => {
  const { attributes } = post as PostProps;
  const { image, title, slug, hook } = attributes;
  const author: User = {
    ...attributes.author?.data.attributes,
    profilePhoto:
      attributes.author?.data.attributes.profilePhoto?.data?.attributes,
  };

  const getTextBlogPostSlug = () => {
    const type = BlogPostType.find(({ type }) => type === slug) || {
      text: "Blog",
      color: "gray",
    };
    return type;
  };

  const imgSrc = image?.data
    ? getUploadUrl(image.data.attributes)
    : "/defaultBlogPost.png";

  return (
    <article className="flex flex-col justify-start rounded-xl shadow-md lg:flex-row">
      <div className="basis-1/5">
        <Image
          className="w-full rounded-tl-xl rounded-tr-xl object-cover lg:h-56 lg:w-56 lg:rounded-bl-xl lg:rounded-tr-none"
          src={imgSrc}
          alt={title}
          width={224}
          height={224}
        />
      </div>
      <div className="flex basis-4/5 flex-col p-6 lg:p-0 lg:px-4">
        <div className="flex flex-row items-center space-x-2 pt-2">
          <time
            dateTime={attributes.publishedAt}
            className="text-xs text-gray-600"
          >
            {capitalize(toRelativeDate(attributes.publishedAt) || "")}
          </time>
          <Tag
            type={getTextBlogPostSlug()?.text}
            color={getTextBlogPostSlug()?.color}
          />
        </div>
        <h3 className="mt-3 text-lg font-semibold leading-6 text-primary underline group-hover:opacity-75">
          <Link href={`/blog/${slug}`}>{attributes.title}</Link>
        </h3>
        <p className="mt-2 line-clamp-3 h-20 text-sm leading-6 text-gray-600">
          {hook}
        </p>
        <div className="relative mt-2 flex items-center gap-x-4">
          <Avatar user={author} size="lg" />
          <div className="text-sm leading-6">
            <p className="font-semibold text-gray-900">
              <span className="absolute inset-0" />
              {author?.firstName} {author?.lastName}
            </p>
            <p className="text-gray-600">Equipo Codealo</p>
          </div>
        </div>
      </div>
    </article>
  );
};

export default ArticleListItem;
